module.exports = __webpack_public_path__ + "static/media/dot.baed861b.svg";